import awardImg from '../Award.svg'
export default function TextExplanation() {

    return (

        <div className='textExplanation' >
            <img alt='award' src={awardImg} />
            <div className='title' > תנאי זכאות: </div>
            <div className='text' >
                <p>
                    1.	כידוע שר הביטחון עשה שימוש בסמכותו הקבועה בסעיף 7 לחוק העיטורים בצבא הגנה לישראל, התש"ל-1970 (להלן: "חוק העיטורים בצה"ל"), והחליט להעניק, באישור הממשלה, אות מערכה לחיילים ששרתו בשירות סדיר או בשירות מילואים ביחידה צבאית שפעלה בגזרת הלבנון או סייעה באופן ישיר ללחימה בגזרת לבנון בתקופת הלחימה של צה"ל בלבנון (להלן: "אות המערכה") בין 30 בספטמבר 1982 ל-24 במאי 2000 (להלן: "התקופה הקובעת") ועומדים בתנאים שנקבעו לקבלת האות.
                </p>
                <p>
                    2.	בהמשך להחלטתו של שר הביטחון כאמור התקין השר לביטחון הפנים, באישור הממשלה, את תקנות העיטורים במשטרת ישראל ובשירות בתי הסוהר (אות המערכה ברצועת הביטחון בלבנון – קביעת זכאים), התשפ"א-2021 (להלן: "התקנות"), שבהן נקבעו, בין היתר, תנאי זכאותם של שוטרים לאות המערכה וזאת מתוקף סמכותו לפי חוק העיטורים במשטרת ישראל ובשירות בתי הסוהר, התשל"ב-1972. בתקנות נקבעו הקריטריונים לזכאות לאות המערכה עבור שוטרים, לרבות שוטרים בחובה ובמילואים ומתנדבים בשירות המשטרה.
                </p>
                <p>
                    3.	בהתאם לתקנות זכאות לקבלת אות מערכה במשטרה תקום לשוטר (לרבות שח"מ) או מתנדב ששירת ביחידה משטרתית מזכה במשך 30 ימים רצופים במהלך התקופה הקובעת שהוא אחד מאלה;
                </p>
                <p>
                    -  שוטר ששירת 30 ימים רצופים לפחות של שירות תקין.
                </p>
                <p>
                    - מתנדב או מי שביצע שירות מילואים במשטרה תקופה כוללת של 30 ימי שירות פעיל לפחות במצטבר במהלך שנה מסוימת מתוך כלל התקופה הקובעת.
                </p>
                <p>
                    - שוטר או מתנדב משטרה וכן מי שביצע שירות מילואים במשטרה תקופה קצרה מ- 30 ימים ואולם הוא נחבל או חלה בשנה מזכה או בתקופה הקובעת, לפי העניין, במהלך שירותו ועקב שירותו או שחבלתו או מחלתו   הוחמרו בשנה מזכה או בתקופה הקובעת, במהלך ועקב שירותו.
                </p>
               <p>
                    -	הוא שירת במהלך התקופה הקובעת וראש אמ"ש או מי שהוא הסמיך לכך הורה כי הוא זכאי לקבלת האות לאחר ששוכנע כי הוא תרם תרומה ישירה לסיוע במאמץ הנלווה ללחימה בגזרת הלבנון או לאורך הגבול ברצועת הביטחון בלבנון או בקו הסגול או כי התקיימו לגביו נסיבות מיוחדות המצדיקות את הענקת האות.
                </p>
                4.	אות המערכה יוענק לשוטר או מתנדב שמופיעה לו במערכת הממוחשבת זכאות לאות מערכת "ללחימה בלבנון".
                <p>
                </p><p>
                    5.	להלן רשימת היחידות המזכות שנקבעו מופיעה בתוספת הראשונה לתקנות :
                </p>
                תוספת ראשונה
                <br />(תקנה 3(א))
                <br />(1)      בירנית (אוגדה 91);
                <br />(2)      יחידות כפריות מג"ב:
                <br />(א)  גוש גליל – החל משנת 1997;
                <br />(ב)  גזרת גליל מערבי;
                <br />(ג)   גזרת גליל עליון;
                <br />(ד)  גזרת ירדן – סיירת המצפים ומחלקת הסיור;
                <br />(ה)  גזרת לבונה / מרכז הגליל;
                <br />(3)      יחידת חבלה צפון;
                <br />(4)      יחידת יג"ל;
                <br />(5)      יחידת מז"פ צפון;
                <br />(6)      יחידת ימ"מ – עד יום י"ט בתמוז התשמ"ג (30 ביוני 1983);
                <br />(7)      יחידת ענף תנועה צפוני;
                <br />(8)      ימ"ר צפון;
                <br />(9)      יס"מ –
                <br />(א)  מרחב גליל;
                <br />(ב)  מרחב חוף;
                <br />(ג)   מרחב עמקים;
                <br />(10)     מטה מחוז צפון –
                <br />(א)  אג"מ;
                <br />(ב)  אח"מ;
                <br />(ג)   אמ"ש;
                <br />(ד)  את"ל;
                <br />(ה)  טכנולוגיות;
                <br />(ו)   לשכת מפקד;
                <br />(11)     מטה מרחב גליל –
                <br />(א)  אג"מ;
                <br />(ב)  אח"מ;
                <br />(ג)   אמ"ן;
                <br />(ד)  אמ"ש;
                <br />(ה)  את"ל;
                <br />(ו)   לשכת מפקד;
                <br />(12)     נקודת שיטור ראש הנקרה;
                <br />(13)     פלוגות מג"ב –
                <br />(א)  פלוגה ג' – מיום י"ג בסיוון התשמ"ד (13 ביוני 1984) עד יום ט"ו באב התשמ"ג (27 באוגוסט 1984);
                <br />(ב)  פלוגה ה' – מיום ג' באב התשמ"ג (13 ביולי 1983) עד יום ג' בחשוון התשמ"ד (10 באוקטובר 1983);
                <br />(ג)   פלוגה ז' – מיום ו' בטבת התשמ"ג (22 בדצמבר 1982) עד יום כ"ה בסיוון התשמ"ג (6 ביוני 1983), ומיום כ"ט באב התשמ"ד (27 באוגוסט 1984) עד יום ט' בכסלו התשמ"ה (3 בדצמבר 1984);
                <br />(ד)  פלוגה י"א – מיום א' בניסן התשמ"ד (3 באפריל 1984) עד יום ג' בסיוון התשמ"ד (13 ביוני 1984);
                <br />(ה)  פלוגה ט"ו – מיום כ"ז בכסלו התשמ"ד (3 בדצמבר 1983) עד יום י' באדר התשמ"ה (3 במרס 1985);
                <br />(ו)   פלוגה כ' – מיום י"ג בתשרי התשמ"ג (30 בספטמבר 1982) עד יום כ"ה בחשוון התשמ"ג (11 בנובמבר 1982), מיום ט' בכסלו התשמ"ג (25 בנובמבר 1982) עד יום ו' בטבת התשמ"ג (22 בדצמבר 1982), ומיום ג' בחשוון התשמ"ד (10 באוקטובר 1983) עד יום ה' בשבט התשמ"ד (9 בינואר 1984);
                <br />(ז)   פלוגה כ"א – מיום י"ג בתשרי התשמ"ג (30 בספטמבר 1982) עד יום ד' בשבט התשמ"ג (18 בינואר 1983), ומיום כ"ה בסיוון התשמ"ג (6 ביוני 1983) עד יום כ"ח בחשוון התשמ"ג (4 בנובמבר 1983);
                <br />(ח)  פלוגה כ"ב – מיום ד' בשבט התשמ"ג (18 בינואר 1983) עד יום ג' באב התשמ"ג (13 ביולי 1983);
                <br />(ט)  פלוגה כ"ג – מיום ה' בשבט התשמ"ד (9 בינואר 1984) עד יום א' בניסן התשמ"ד (3 באפריל 1984);
                <br />(14)     תחנת גולן;
                <br />(15)     תחנת ירדן (ראש פינה);
                <br />(16)     תחנת נהריה;
                <br />(17)     תחנת עכו;
                <br />(18)     תחנת צפת;
                <br />(19)     תחנת קריית שמונה.
            </div>
        </div>
    )
}

